import {
  HOST_TO_COUNTRY,
  LOCALIZED_HOST_SET,
  PRIMARY_HOSTS,
} from "@constants/localizedHosts"
import get from "lodash-es/get"

type PriceKey = "compareAtPrice" | "price"

const resolveHostname = (explicit?: string) => {
  return (
    explicit ?? (typeof window !== "undefined" ? window.location.hostname : "")
  )
}

const marketFromHost = (hostname: string): string => {
  const host = hostname.toLowerCase().split(":")[0]

  if (PRIMARY_HOSTS.has(host)) {
    return "US"
  }

  if (LOCALIZED_HOST_SET.has(host)) {
    return HOST_TO_COUNTRY[host] || "US"
  }

  return "US"
}

/**
 * Domain dictates market:
 *  - Primary hosts: always US pricing
 *  - Localized hosts: pricing for the domain’s mapped country
 *  - Unknown hosts (dev/preview): US
 *
 * `countryCode` is ignored whenever the hostname maps to a known market
 */
export const getMarketAmount = (
  variant: any,
  _countryCode: string, // Intentionally unused, legacy param
  key: PriceKey,
  opts?: { hostname?: string }
) => {
  const chosenCountry = marketFromHost(resolveHostname(opts?.hostname))

  const amount =
    get(variant, `marketPrices.${chosenCountry}.${key}.amount`) ??
    get(variant, `marketPrices.US.${key}.amount`) ??
    variant?.[key] ??
    0

  return typeof amount === "string" ? Number(amount) : amount
}
